import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SidebarWidgets = () => {
    const [data, setData] = useState(null);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [time, setTime] = useState(new Date());

    // Clock
    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    // Fetch Data (Weather + Analytics)
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Parallel Fetch
                const [weatherRes, statsRes] = await Promise.allSettled([
                    axios.get('/api/weather/sidebar-data'),
                    axios.get('/api/analytics/stats')
                ]);

                if (weatherRes.status === 'fulfilled') setData(weatherRes.value.data);
                if (statsRes.status === 'fulfilled') setStats(statsRes.value.data);

            } catch (error) {
                console.error("Sidebar widget error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) return <div style={{ padding: '20px', textAlign: 'center', fontSize: '0.8rem', color: '#666' }}>Initializing Env_Sys...</div>;

    // Helpers
    const formatTime = (date) => date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const temp = data?.current?.temp;
    const desc = data?.current?.description;

    // Earthquake / Alerts
    const recentQuake = data?.quake?.features?.[0];

    return (
        <div style={{ marginTop: '20px', borderTop: '2px solid #111', paddingTop: '20px' }}>
            {/* 1. CLOCK */}
            <div style={{ marginBottom: '15px', fontFamily: 'monospace', textAlign: 'center' }}>
                <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{formatTime(time)}</div>
                <div style={{ fontSize: '0.7rem', color: '#666' }}>{time.toLocaleDateString()}</div>
                <div style={{ fontSize: '0.7rem', color: 'green' }}>● SYSTEM ONLINE</div>
            </div>

            {/* 2. WEATHER MINI */}
            {data?.debug_error && (
                <div style={{ color: 'red', fontSize: '0.6rem', marginBottom: '5px', background: '#fee', padding: '2px' }}>
                    API Error: {typeof data.debug_error === 'object' ? JSON.stringify(data.debug_error) : data.debug_error}
                </div>
            )}
            <div className="sidebar-widget" style={{ marginBottom: '15px', background: '#f4f4f4', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}>
                <div style={{ fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '5px' }}>
                    Conditions @ {data?.location?.name || 'Local'}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{temp ? Math.round(temp) : '--'}°F</div>
                    <div style={{ fontSize: '0.8rem', textAlign: 'right' }}>{desc || 'N/A'}</div>
                </div>
            </div>

            {/* 3. ENV STATUS (FORECAST & ALERTS) */}
            <div className="sidebar-widget" style={{ fontSize: '0.8rem', fontFamily: 'monospace' }}>

                {recentQuake && (
                    <div style={{ borderBottom: '1px dashed #999', paddingBottom: '5px', marginBottom: '5px', color: '#8b0000' }}>
                        <strong>⚠️ {recentQuake.properties?.mag === 'WX' ? 'WEATHER ALERT' : 'SEISMIC ALERT'}:</strong><br />
                        {recentQuake.properties?.place}
                    </div>
                )}

                {/* Forecast list */}
                {data?.forecast?.list && (
                    <div>
                        <strong>FORECAST:</strong>
                        {data.forecast.list.slice(0, 3).map((f, i) => (
                            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2px', color: '#444' }}>
                                <span>{new Date(f.dt * 1000).getHours()}:00</span>
                                <span>{Math.round(f.main.temp)}°F</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* 4. NETWORK ANALYTICS (NEW) */}
            <div className="sidebar-widget" style={{ fontSize: '0.75rem', fontFamily: 'monospace', marginTop: '15px', color: '#333', borderTop: '1px dashed #999', paddingTop: '10px' }}>
                <div style={{ textTransform: 'uppercase', fontWeight: 'bold', marginBottom: '5px' }}>
                    Network Traffic
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>TOTAL HITS:</span>
                    <span>{stats?.totalVisits?.toLocaleString() || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#555' }}>
                    <span>UNIQUE IP:</span>
                    <span>{stats?.uniqueVisitors?.toLocaleString() || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#d32f2f' }}>
                    <span>BOTS / AI:</span>
                    <span>{stats?.botTraffic?.toLocaleString() || 0}</span>
                </div>
                <div style={{ fontSize: '0.65rem', fontStyle: 'italic', marginTop: '5px', color: '#666', lineHeight: '1.2' }}>
                    * This might look like a promotion for Cloudflare, but if bot traffic is low, it means they are doing a really good job.
                </div>
            </div>
        </div>
    );
};

export default SidebarWidgets;
